import { Column } from 'common/models/Projection';

export enum SeriesType {
  LINE,
  BAR,
}

export interface SeriesParams {
  stroke?: string;
  fill?: string;
  strokeOpacity?: number;
}

export interface Series {
  data: Column[];
  type: SeriesType;
  label: string;
  shortLabel: string;
  tooltipLabel: string;
  params?: SeriesParams;
}

export enum ExploreMetric {
  CASES,
  DEATHS,
  HOSPITALIZATIONS,
  ICU_HOSPITALIZATIONS,
  VACCINATIONS_FIRST_DOSE,
  VACCINATIONS_COMPLETED,
  ICU_USED,
  POSITIVITY_RATE,
}

export enum DataMeasure {
  INTEGER,
  PERCENT,
}
